import Vue from "vue"
import Toasted from "vue-toasted"

Vue.use(Toasted, {
	className: "toast",
	containerClass: "toast-container",
	position: "bottom-right",
	duration: 5000,
})
